import { useTags } from "@app/shared/components/TagListEditor/data";
import { Icon } from "@design-system/Icon";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { TagType } from "@generated/client/graphql";
import { type FC } from "react";
import { useOpenQuestionnaireModalTranslations } from "./i18n";

export const SelectQuestionnaireDropdown: FC<{
    selectedQuestionnaireTag: { id: string; name: string };
    setSelectedQuestionnaireTag: (tag: { id: string; name: string }) => void;
}> = ({ selectedQuestionnaireTag, setSelectedQuestionnaireTag }) => {
    const { tags } = useTags(TagType.Questionnaire);

    const { t, keys } = useOpenQuestionnaireModalTranslations();

    const displayedTrigger = selectedQuestionnaireTag.id
        ? selectedQuestionnaireTag.name
        : t(keys.select_questionnaire_placeholder);

    const handleTagChange = (value: string[]) => {
        const selectedTagId = value[0];
        const tag = tags?.find((tag) => tag.id === selectedTagId);
        if (tag) {
            setSelectedQuestionnaireTag(tag);
        }
    };

    return (
        <Dropdown
            value={[selectedQuestionnaireTag.id]}
            onValueChange={handleTagChange}
            selectType="single"
        >
            <Dropdown.Trigger>
                <FlexRow
                    w="full"
                    px="2"
                    py="4"
                    br="lg"
                    alignItems="center"
                    justifyContent="between"
                    className="border border-secondary text-primary"
                >
                    <FlexRow alignItems="center" gap="2">
                        <Icon name="document" />
                        <Text>{displayedTrigger}</Text>
                    </FlexRow>
                    <Icon name="chevronDown" />
                </FlexRow>
            </Dropdown.Trigger>
            <Dropdown.Content align="start" hasPortal>
                {tags?.map((tag) => (
                    <Dropdown.SelectableItem key={tag.id} value={tag.id}>
                        <Dropdown.SelectedIndicator />
                        {tag.name}
                    </Dropdown.SelectableItem>
                ))}
            </Dropdown.Content>
        </Dropdown>
    );
};
